import DocumentIcon from '@material-symbols/svg-400/outlined/description.svg?react';
import ArrowBackIcon from '@material-symbols/svg-400/outlined/keyboard_backspace.svg?react';
import { useCallback, useState } from 'react';
import { Clause } from '~/api/def/endpoints/obligationsEndpoint';
import { Link } from '@tanstack/react-router';
// import { DocumentPDFViewer } from "~/components/ui/vendor/pdf/document_pdf_viewer";
// import { DocumentPDFViewer as ClientPDFViewer } from "./document_viewer.client";
import { DocumentPDFViewer as ClientPDFViewer } from '~/components/ui/vendor/pdf/document_pdf_viewer/DocumentPdfViewer';
import { Document } from '~/lib/pdfViewer/types';
export interface LeftSideProps {
  clause: Clause;
  doc: Pick<Document, 'id' | 'investor' | 'name' | 'agreementTypeName'>;
  fullText: string;
  scrollToClause: () => void;
}
function LeftSide({ clause, doc, fullText, scrollToClause }: LeftSideProps) {
  return (
    <>
      <h3>{clause.title}</h3>
      <p>{clause.summary}</p>

      <div className="infoblock">
        <div className="item">
          <div>Obligation Owner</div>
          <div>{clause.owner?.name || '-'}</div>
        </div>
      </div>

      <h3>Obligation Reference</h3>
      <div className="infoblock">
        {/* biome-ignore lint/a11y/useValidAnchor: Maybe valid, but to scroll PDF reader */}
        <a
          href="#"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            scrollToClause();
          }}
        >
          {fullText}
        </a>
      </div>

      <h3>Document Reference</h3>
      <div className="infoblock">
        <div className="item">
          <div>Fund</div>
          <div>
            <Link to={`/documents/fund/${clause.fund.id}`}>
              {clause.fund.name}
            </Link>
          </div>
        </div>
        <div className="item">
          <div>Document Type</div>
          <div>{doc.agreementTypeName}</div>
        </div>
        <div className="item">
          <div>Source Document</div>
          <div>
            <Link to={`/documents/overview/${doc.id}`}>
              <DocumentIcon />
              {doc.name}
            </Link>
          </div>
        </div>
      </div>

      <h3>Investors</h3>
      <div className="infoblock">
        <div className="item">
          <div>Investor</div>
          <div>{doc.investor || '-'}</div>
        </div>
      </div>
    </>
  );
}
export interface RightSideProps {
  documentId: string;
  clause: Clause;
  isScrolledToClause: boolean;
  onScrollAway?(): void;
}
function RightSide({
  documentId,
  clause,
  isScrolledToClause,
  onScrollAway,
}: RightSideProps) {
  // return <>Pdf viewer</>;
  return (
    <ClientPDFViewer
      documentId={documentId}
      clauses={[clause]}
      fieldTypes={null}
      activeHighlight={isScrolledToClause ? clause.clauseId : null}
      onScrollAway={onScrollAway}
    />
  );
}

export interface ClauseLayoutProps {
  clause: Clause;
  document: Pick<Document, 'id' | 'investor' | 'name' | 'agreementTypeName'>;
  fullText: string;
}
export function ClauseLayout({
  clause,
  document,
  fullText,
}: ClauseLayoutProps) {
  // const { clause, doc, fullText } = useLoaderData<typeof loader>();

  /* Fiddly scroll management */
  const [isScrolledToClause, setScrolledToClause] = useState(false);
  const scrollToClause = useCallback(() => setScrolledToClause(true), []);
  const unsetScrollToClause = useCallback(() => setScrolledToClause(false), []);
  return (
    <div className="clauselayout">
      <div className="navback">
        <Link
          className="arrow-left"
          to="/obligations"
          style={{ textDecoration: 'none' }}
        >
          <ArrowBackIcon
            style={{
              height: '1.5rem',
              width: '2rem',
              verticalAlign: '-0.3rem',
            }}
          />
        </Link>
      </div>
      <div className="leftright">
        <div className="left">
          <LeftSide
            clause={clause}
            doc={document}
            fullText={fullText}
            scrollToClause={scrollToClause}
          />
        </div>
        <div className="right">
          <RightSide
            documentId={document.id}
            clause={clause}
            isScrolledToClause={isScrolledToClause}
            onScrollAway={unsetScrollToClause}
          />
        </div>
      </div>
    </div>
  );
}
